module.exports = __webpack_public_path__ + "static/media/error.32fc22b2.mp3";